import * as Blockly from "blockly";

export class FieldJsonModalBase extends Blockly.FieldTextInput {
  public static SERIALIZABLE = true;
  public override SERIALIZABLE = true;

  public static override fromJson<T extends FieldJsonModalBase>(
    this: new (value?: string) => T,
    options: Blockly.FieldConfig & { text?: string },
  ): T {
    const text = Blockly.utils.parsing.replaceMessageReferences(
      options.text ?? "{}",
    );
    return new this(text);
  }

  constructor(value: string = "{}") {
    super(value);
  }

  protected override getDisplayText_(): string {
    const value = this.getValue() ?? "";
    if (!value) return "{}";
    return value.length > 40 ? `${value.substring(0, 40)}…` : value;
  }

  protected normalizeEditorValueForSave(value: string): string {
    try {
      return JSON.stringify(JSON.parse(value));
    } catch {
      return value;
    }
  }
}
